import * as React from 'react';

import { Col, Row } from 'antd';

import { AnimatedHeader } from 'src/components/animatedHeader';
import { AppButton } from 'src/components/appButton';
import { PageWrapper } from 'src/components/pageWrapper';
import { UnorderedListOutlined } from '@ant-design/icons';
import { useAppRoutes } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface IntroPageProps {

}

export const IntroPage: React.FC<IntroPageProps> = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const appRoutes = useAppRoutes();

    return (
        <PageWrapper>
            <Row
                align="middle"
                justify="space-around"
                gutter={20}
            >
                <Col
                    span={24}
                >
                    <AnimatedHeader
                        header={t('Pages.IntroPage.header')}
                        subheader={t('Pages.IntroPage.subheader')}
                        fadeDirection="up"
                    />
                </Col>

                <Col
                    style={{ marginTop: 50 }}
                >
                    <AppButton
                        size="middle"
                        icon={<UnorderedListOutlined />}
                        type="primary"
                        onClick={() => navigate(appRoutes.interview.path)}
                    >
                        {t('Pages.IntroPage.start_interview_button_text')}
                    </AppButton>
                </Col>
            </Row>
        </PageWrapper>
    );
};